import { CONFIG } from "~/config";
import { node } from "~/util/dom";

export default class FandaCategory {
	#container: HTMLDivElement;

	#count: HTMLSpanElement;

	constructor(text, count) {
		this.#container = node("div", { className: "ui-fandaCategory" });
		this.#count = node("span", { className: "ui-fandaCategory__number" });
		this.#container.append(node("span", { className: "ui-fandaCategory__text" }, text), this.#count);
		this.count = count;
	}

	get container() {
		return this.#container;
	}

	set count(count) {
		let currentCount = 0;

		this.#count.classList[count ? "add" : "remove"]("ui-fandaCategory__number--full");

		if (count > 0) {
			const countInterval = setInterval(container => {
				currentCount += Math.floor(count / (count > 100 ? 100 : count));
				container.innerHTML = new Intl.NumberFormat(CONFIG.defaultLang).format(currentCount);

				if (currentCount >= count) {
					container.innerHTML = new Intl.NumberFormat(CONFIG.defaultLang).format(count);
					clearInterval(countInterval);
				}
			}, 10, this.#count);
		} else {
			this.#count.innerHTML = count.toString();
		}
	}
}
